import { QueryClient, UseMutationResult } from 'react-query';
import HttpServiceHelper from './httpServiceHelper';
import { _HttpMethods, _Payload, _Permission, _PermissionGroup } from '../constants/staticTypes';
import {
    addOrgPermissionApi,
    deleteOrgPermissionApi,
    getOrgPermissionGroupListApi,
    getOrgPermissionListApi,
    getPermissionGroupsForVenueApi,
    updateOrgPermissionApi,
} from '../constants/apiEndPoints';
import { AxiosResponse } from 'axios';
import { getErrorMessage } from '../utils/common';
import { AlertVariant } from '../constants/constants';
import { _UpdatePermissionForm } from './permissionHelper';

export const getOrgStaffPermissionList = (queryClient: QueryClient, limit = 500) => {
    const url = `${getOrgPermissionListApi}?limit=${limit}`;
    return HttpServiceHelper({
        url,
        method: _HttpMethods.GET,
        queryClient,
    });
};

export const getOrgStaffPermissionGroupList = (queryClient: QueryClient, limit = 500) => {
    const url = `${getOrgPermissionGroupListApi}?limit=${limit}`;
    return HttpServiceHelper({
        url,
        method: _HttpMethods.GET,
        queryClient,
    });
};

export const getOrgPermissionWithGroupList = async (queryClient: QueryClient) => {
    const [adminOrgPermissionListResponse, adminOrgPermissionGroupListResponse] = await Promise.all([
        getOrgStaffPermissionList(queryClient),
        getOrgStaffPermissionGroupList(queryClient),
    ]);
    return {
        adminOrgPermissionListData: adminOrgPermissionListResponse?.data?.data as _Permission[],
        adminOrgPermissionGroupListData: adminOrgPermissionGroupListResponse?.data?.data?.lists as _PermissionGroup[],
    };
};

export type _AddPermissionForm = {
    permissionRoleName: string;
    permissionRoleDescription: string;
};

export const addOrgPermission = (
    addAdminOrgPermissionMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: _AddPermissionForm,
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    addAdminOrgPermissionMutation.mutate(
        {
            url: addOrgPermissionApi,
            method: _HttpMethods.POST,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};

export const updateOrgPermission = (
    updateAdminPermissionMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: _UpdatePermissionForm,
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    updateAdminPermissionMutation.mutate(
        {
            url: updateOrgPermissionApi,
            method: _HttpMethods.PUT,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};

export const deleteOrgPermission = (
    deleteAdminOrgPermissionMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: { id: string },
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    deleteAdminOrgPermissionMutation.mutate(
        {
            url: deleteOrgPermissionApi,
            method: _HttpMethods.DELETE,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};

export const getVenuePermissionGroupList = (queryClient: QueryClient, tenantId: string, limit = 500) => {
    const url = `${getPermissionGroupsForVenueApi}/${tenantId}?limit=${limit}`;
    return HttpServiceHelper({
        url,
        method: _HttpMethods.GET,
        queryClient,
    });
};
